// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "host" + "." + "1f9d0e3e6654660cc77d" + ".min.css";
};